import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserLostPasswordFormValidator from './views/UserLostPasswordFormValidator';

export default class UserLostPasswordNode extends NodeModule {
  start(options) {
    console.log('Starting User Lost Password');
    const userLostPassword = new Form({el: options.el, formEl: '#loginForm', type: (opts) => new UserLostPasswordFormValidator(opts)});
  }
}